<template>
    <div>
        <v-btn 
                v-if="!details"
                tile
                elevation="0"
               :disabled="outOfStock"
               :loading="$wait.is(`loading clickAndCollect addBundleToCart ${bundle.campaignId} *`)"
               style="max-width: 72px; max-height: 44px"
               color="black"
               @click.stop="addBtnAction($event)"
               :class="$vuetify.breakpoint.smAndDown ? 'buy-btn': 'buy-btn'"
               class="fxt-buy-btn"
        >
            <span>
                <span>
                    Kjøp
                </span>
            </span>
        </v-btn>
        <v-btn 
                v-else
                :block="!hideBtnText"
               :disabled="outOfStock"
               :loading="$wait.is(`loading clickAndCollect addBundleToCart ${bundle.campaignId} *`)"
               class="px-2 px-4 fxt-buy-btn"
               color="black"
               tile
               elevation="0"
               style="max-width: 170px;"
               @click.stop="addBtnAction($event)"
        >
            <span>
                <span :class="{'hidden-sm-and-down': hideBtnText}">
                    {{ outOfStock ? 'Tom på lager' : (buttonHtml ? buttonHtml.text : 'Kjøp') }}
                </span>
                <v-icon
                    v-show="$vuetify.breakpoint.smAndDown || (!outOfStock && (!buttonHtml || (buttonHtml && buttonHtml.icon)))"
                    :size="$vuetify.breakpoint.smAndDown ? 20 : 24">
                    {{ buttonHtml ? buttonHtml.icon : 'fxt-cart' }}
                </v-icon>
            </span>
        </v-btn>
    </div>
</template>

<script>
import webshopMixins from '@/components/webshop/cart/webshop.mixins.js'
import {debounce} from 'lodash-es';

export default {
    mixins: [webshopMixins],
    methods: {
        async addBtnAction(e) {
            this.$store.dispatch('webshop/set', {key: 'addedToCartDialog', value: false});
            // if (this.salons.length === 1) {
                await this.$store.dispatch('campaigns/set', {key: 'bundle', value: this.bundle});
                await this.$store.dispatch('webshop/set', {key: 'selectedBundle', value: this.bundle});
                this.addBundleToSalonCart(this.salons[0]);
            // } else {
            //     this.openSalonSelectDialog(e)
            // }
        },

        async openSalonSelectDialog(e) {
            e.preventDefault();
                await this.$store.dispatch('webshop/set', {key: 'selectedBundle', value: this.bundle});
                this.$store.dispatch('campaigns/set', {key: 'bundle', value: this.bundle});
                this.$store.dispatch('webshop/set', {key: 'bundleSalonPickOptions', value: {dialog: true}});
        }
    },
    data() {
        return {
            addedToCartText: false,
            debounceButtonText: debounce(function () {
                this.addedToCartText = false;
            }, 2000)
        }
    },
    computed: {
        outOfStock() {
            return this.bundle.onlineStock === 0;
        },

        cartProduct() {
            return this.$store.getters['clickAndCollect/get']('items').find(x => x.id === this.bundle.campaignId)
        },

        selectedProductId() {
            return this.$store.getters['webshop/get']('selectedBundle').camapignId || this.$route.params.campaignId
        }
    },
    props: {
        hideBtnText: Boolean,
        hideQuantity: Boolean,
        buttonHtml: Object,
        details: Boolean,
        bundle: {
            type: Object,
            default: null
        },
    }
}
</script>
<style lang="scss">
.v-btn:not(.v-btn--round).v-size--small {
    padding: 0 !important;
}
</style>